// First, before anything that can read the URL: see `strip-link-credentials`.
import "./lib/concierge/strip-link-credentials";

import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { initErrorTracking } from "@/lib/sentry";
import reportWebVitals from "./reportWebVitals";

import "./main.css";
import { Providers } from "./providers";
import { router } from "./router";

// Before the app renders, so bootstrap errors are captured too. No-op unless
// running in a deployed environment - see `@/lib/sentry` for why.
initErrorTracking();

const rootElement = document.getElementById("app");

if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
